var favButtonsArr = document.querySelectorAll('.btn--heart');
var favourites = [];

// Get Favourites from local storage if available
function fetchFavourites() {
    if (localStorage.getItem('favourites')) {
        favourites = JSON.parse(localStorage.getItem('favourites'));
    }
    // Create Favourites array in localStorage
    else {
        localStorage.setItem('favourites', JSON.stringify(favourites));
    }
    buildFavourites();
}
fetchFavourites();

// build favourites on reload
function buildFavourites() {
    favourites.forEach(favourite => {
        favButtonsArr.forEach(button => {
            button.id === favourite ?
                button.childNodes[1].classList.toggle('fas') :
                null;
        });
    });
}

favButtonsArr.forEach(element =>
    // add listener to fav button
    element.addEventListener('click', event => {
        event.preventDefault();
        // get card (parent) Id
        let prodId = element.id;
        let icon = element.childNodes[1];
        // Check if already in favourites

        if (favourites.includes(prodId)) {
            favourites = favourites.filter(id => id !== prodId);
            localStorage.setItem('favourites', JSON.stringify(favourites));
            icon.classList.remove('fas');
            document.cookie = 'favourites=' + JSON.stringify(favourites) + ';path=/;';
        } else {
            favourites.push(prodId);
            localStorage.setItem('favourites', JSON.stringify(favourites));
            document.cookie = 'favourites=' + JSON.stringify(favourites) + ';path=/;';
            icon.classList.add('fas');
        }
    })
);